module.exports = {"labels":{"axis":"EIXOS","plate":"PLACA","confirmPlate":"CONFIRMAR PLACA","identifier":"Nº DA VELOETAG","submitButton":"Ativar VeloeTag","addInformation":"Add informação"},"titleModal":"VeloeTag ativada com sucesso! Com restrição no cadastro","titleModalError":"Erro ao ativar sua VeloeTag","modalDescriptionError":"Por favor, tente novamente.","title":"Ativar VeloeTag","paragraph":"Informe o tipo do seu veículo e o número da VeloeTag que recebeu.","textInfo":"Tipo do veículo*","mandatoryInfo":"*Campo obrigatório"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ActivationForPartner/data.json
// module id = 674
// module chunks = 0